// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FDjBS","col":"styles_col__3cm1N"};